/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedContactDealerButton_user = {
    readonly " $fragmentRefs": FragmentRefs<"SharedContactDealerWrapper_user" | "TradeOnboardingCoachmarkConditionalLoader_user" | "PdpRespTradeOnApprovalCoachmarkLoader_user">;
    readonly " $refType": "PdpSharedContactDealerButton_user";
};
export type PdpSharedContactDealerButton_user$data = PdpSharedContactDealerButton_user;
export type PdpSharedContactDealerButton_user$key = {
    readonly " $data"?: PdpSharedContactDealerButton_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedContactDealerButton_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedContactDealerButton_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "TradeOnboardingCoachmarkConditionalLoader_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespTradeOnApprovalCoachmarkLoader_user",
      "args": null
    }
  ]
};
(node as any).hash = '601b0173384836cb8249f847605bfd78';
export default node;
